module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol/iterator.js
// module id = 97
// module chunks = 0 2 3 4 5 6 7 8 11 12 13 14 15 16 17 18 20